import { useState } from 'react';
import { mapArrayDropdownOptions } from 'utils/funciones';
import { consumirServicioEncirptacion } from '../api';
import { urlEmisionPoliza } from '../constants/urls';

const useBuscarColonias = () => {
  const [colonias, setColonias] = useState([]);
  const buscarColonias = async (
    { codPais, codDpto, codMunicipio },
    codigoPostal = null,
  ) => {
    if (codPais && codDpto && codMunicipio) {
      const Data = {
        datosCotizador: {
          prodCodigo: 'TRAVELBTA',
          cotPasoCodigo: 'colonias',
          codPais,
          codDepartamento: codDpto,
          codMunicipio,
          codPostal: codigoPostal,
        },
      };
      const res = await consumirServicioEncirptacion(urlEmisionPoliza, Data);
      const data = res?.catalogo?.colonias?.map(mapArrayDropdownOptions) || [];
      setColonias([...data]);
      return data;
    }
  };

  return { buscarColonias, colonias, setColonias };
};

export default useBuscarColonias;
